import { hasPermission } from '@/hooks/useBackendMenu'
import { zod } from '@acme/core'
import { Grid } from '@mui/material'
import { FormFieldCheckbox } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import Dialog from 'global/guides/Dialog'
import { useState } from 'react'
import { empresas } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import DialogSucesso from './DialogSucesso'

export default function ConfiguracaoEspelhoPonto() {
    const [open, setOpen] = useState(false)
    const data = useStore(state => state.company)
    const { mutateAsync } = empresas.mutations.useUpdate({
        invalidateQuery: true,
        onSuccess: () => {
            setOpen(true)
        },
        onError: e => {
            toast.error(e.message)
        },
    })
    const canView = hasPermission(['update', 'EspelhoDoPonto'])

    return !data ? null : (
        <Dialog.Root
            height="auto"
            width="fit-content"
            onSubmit={values => {
                mutateAsync({
                    ...data,
                    ocultarInfoRodapeEspelho: values.ocultarInfoRodapeEspelho,
                })
            }}
            schema={zod.EmpresaSchema.pick({ ocultarInfoRodapeEspelho: true })}
            defaultValues={data}
            open={canView}
        >
            <DialogSucesso open={open} />
            <Dialog.Title>Configuração - {data.nomeFantasia}</Dialog.Title>
            <Dialog.Content dividers>
                <Grid container>
                    <Grid
                        item
                        xs={12}
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <FormFieldCheckbox
                            name="ocultarInfoRodapeEspelho"
                            label="Reduzir informações do rodapé"
                        />
                        <IconeAjuda>
                            <span>
                                <span>
                                    Quando habilitado, os seguintes dados do
                                    rodapé serão ocultados:
                                </span>
                                <br />
                                <br />
                                <ul style={{ marginLeft: '20px' }}>
                                    <li>Saldo anterior</li>
                                    <li>Saldo atual</li>
                                    <li>Saldo da competência</li>
                                    <li>Horas a trabalhar</li>
                                    <li>Horas trabalhadas</li>
                                    <li>Faltas integrais</li>
                                    <li>Faltas parciais</li>
                                    <li>Desconto do DSR</li>
                                </ul>
                            </span>
                        </IconeAjuda>
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
